import { InfoIcon } from "lucide-react";

export default function Description({ children }) {
    return (
        <div className="flex justify-between items-center">
            {children}
            {/* Add back when there are tooltip */}
            {/* <InfoIcon width="1em" height="1em" className="" /> */}
        </div>
    );
}
